










































import dayjs from 'dayjs';
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import EventHistoryDetail from '@/components/molecules/EventHistoryDetail.vue';
import { CalendarEvent } from '@/types/type';
import { EventType } from '@/utils/EventCalendarUtils';
import { newPortalDate } from '@/utils/PortalDate';
import { Day } from '@/utils/consts';

@Component({ components: { EventHistoryDetail } })
export default class EventItem extends Vue {
  @Prop()
  private isFromDialog!: boolean;

  @Prop()
  private event!: CalendarEvent;

  @Prop()
  private loginName!: string;

  private selectedOpen: boolean = false;
  private selectedEventStartElement: HTMLElement | null = null;

  private get isPublicHoliday(): boolean {
    return this.event.eventType === EventType.PublicHoliday;
  }

  private get isCustomHoliday(): boolean {
    return this.event.eventType === EventType.CustomHoliday;
  }

  private get isNormalEvent(): boolean {
    return this.event.eventType === EventType.NormalEvent;
  }

  private showEventHistory(eventStart: string) {
    const open = () => {
      this.selectedEventStartElement = this.$refs[
        `childDayLabel${eventStart}`
      ] as HTMLElement;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => (this.selectedOpen = true))
      );
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }
  }

  private dayOfWeekIsSunOrMon(): boolean {
    const day = newPortalDate(dayjs(this.event.start)).get('day');
    return day === Day.Sunday || day === Day.Monday;
  }

  private calculateNudgeRight(): number {
    if (!this.dayOfWeekIsSunOrMon()) {
      return 0;
    }
    const pixelFromDialog = 232;
    const pixelFromPanel = 8;
    return this.isFromDialog ? pixelFromDialog : pixelFromPanel;
  }

  private calculateNudgeLeft(): number {
    if (this.dayOfWeekIsSunOrMon()) {
      return 0;
    }
    const pixelFromDialog = 16;
    const pixelFromPanel = 8;
    return this.isFromDialog ? pixelFromDialog : pixelFromPanel;
  }

  private close(): void {
    this.selectedOpen = false;
  }
}
